import * as RadixPopover from '@radix-ui/react-popover';
import type { ReactNode } from 'react';

export interface PopoverProps {
  trigger: ReactNode;
  content: ReactNode;
  onOpenChange?: (open: boolean) => void;
  onInteractOutside?: (e: any) => void;
  preventFocusOnOpen?: boolean;
  open?: boolean;
  side?: RadixPopover.PopoverContentProps['side'];
}

export const Popover = ({
  trigger,
  content,
  onOpenChange,
  onInteractOutside,
  preventFocusOnOpen,
  open,
  side,
}: PopoverProps) => (
  <RadixPopover.Root onOpenChange={onOpenChange} open={open}>
    <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
    <RadixPopover.Portal>
      <RadixPopover.Content
        sideOffset={5}
        side={side}
        onInteractOutside={onInteractOutside}
        // Capped to the room Radix measured between trigger and viewport edge,
        // so content that outgrows the screen scrolls instead of running off it
        // and taking whatever it covers out of reach. The flex column lets a
        // child scroll itself (pinning footers); others fall back to this cap.
        className="animate-in fade-in zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 isolate z-20 flex max-h-[calc(var(--radix-popover-content-available-height)-0.5rem)] flex-col overflow-y-auto rounded bg-white p-5 shadow-lg will-change-[transform,opacity]"
        onOpenAutoFocus={(e) => {
          if (preventFocusOnOpen) {
            e.preventDefault();
          }
        }}
        onCloseAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        {content}
        <RadixPopover.Arrow className="fill-white" />
      </RadixPopover.Content>
    </RadixPopover.Portal>
  </RadixPopover.Root>
);

export const PopoverClose = RadixPopover.Close;
